import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";

export function LoadingSpinner() {
  const { t } = useTranslation();

  // on the body: inside a transformed parent (e.g. a sliding payment flow
  // step) `fixed` would only cover that parent, not the screen
  return createPortal(
    <div className="fixed inset-0 bg-gray-950/20 z-[10000] flex items-center justify-center">
      <div className="bg-white w-[24vw] h-[24vw] rounded-lg shadow-lg relative flex flex-col items-center justify-center">
        <div
          className="w-[100px] h-[100px] bg-no-repeat bg-cover absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
          style={{
            backgroundImage: "url('/assets/images/gifs/loader-frames.gif')",
          }}
        />
        <span className="absolute top-[80%] left-1/2 -translate-x-1/2 -translate-y-1/2 font-fancy text-bub-darker-blue">
          {t("Kérlek várj...")}
        </span>
      </div>
    </div>,
    document.body,
  );
}
